import { NgClass } from '@angular/common'
import {
  Component,
  HostListener,
  Input,
  PLATFORM_ID,
  inject,
} from '@angular/core'
import { RouterLink } from '@angular/router'

import { TranslatePipe, TranslateService } from '@ngx-translate/core'

import type { BreadcrumbItem } from '../../types/types'

@Component({
  selector: 'dhp-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  imports: [NgClass, RouterLink, TranslatePipe],
})
export class BreadcrumbsComponent {
  private platformId = inject(PLATFORM_ID)
  private translateService = inject(TranslateService)

  // TODO: Skipped for migration because:
  //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
  //  and migrating would break narrowing currently.
  @Input() crumbs: BreadcrumbItem[] = []
  showDialog = false
  dialogPosition = { top: 0, left: 0 }
  maxLength = 20

  shouldCollapse(): boolean {
    if (!this.crumbs) return false
    return this.crumbs.length > 4
  }

  getHiddenCrumbs(): BreadcrumbItem[] {
    if (!this.crumbs || this.crumbs.length <= 2) return []
    // Return all items except first and last
    return this.crumbs.slice(1, -1)
  }

  toggleDialog(event: MouseEvent): void {
    this.showDialog = !this.showDialog
    event.stopPropagation()
  }

  @HostListener('document:click')
  closeDialog(): void {
    this.showDialog = false
  }

  getLabel(label: string | number): string {
    if (typeof label === 'number') return String(label)
    return label
  }

  truncateText(text: string, maxLength: number): string {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text
  }
}
